import { HttpResult } from "widgets-for-react";
import { ApiResult } from "./apiTypes";
import { Iterable } from "immutable"

export const catchError: <A>() => (e: any) => ApiResult<A> = <A>() => e => {
  console.log(e);
  return "error" as ApiResult<A>;
};

export const handle: <RESULT>(response: Response) => Promise<HttpResult<RESULT>> = async <RESULT>(res: Response) => {
  if (400 <= res.status && res.status < 500)
    return { kind: 'unauthorized', status: res.status }

  if (res.status >= 500)
    return { kind: 'failed', status: res.status }

  const result = await res.json() as RESULT

  return {
    kind: 'result',
    status: 200,
    value: result
  }
}

export const ready = <T>(result: ApiResult<T>): result is T => result != 'loading' && result != 'error'

export const hasValues = <K, V>(result: ApiResult<Iterable<K, V>>): result is Iterable<K, V> => ready(result) && !result.isEmpty()
